export const STATUS_MAP = {
  published: 'Опубликовано',
  planned: 'Запланировано',
  hidden: 'Скрыто',
} as const;

export const SECTION_MAP = {
  Main: 'Главная',
  Feeding: 'Прикорм',
} as const;

export const STATUS_OPTIONS = [
  { id: 'published', title: 'Опубликовано' },
  { id: 'planned', title: 'Запланировано' },
  { id: 'hidden', title: 'Скрыто' },
];

export const TEXT_COLOR_OPTIONS = [
  { id: '#000000', title: 'Черный' },
  { id: '#FFFFFF', title: 'Белый' },
];

export const BUTTON_TYPE_OPTIONS = [
  { id: 'none', title: 'Без кнопки' },
  { id: 'text', title: 'Текст' },
  { id: 'icon', title: 'Иконка' },
];

export const ACTION_OPTIONS = [
  { id: 'link', title: 'Ссылка' },
  { id: 'modal', title: 'Модалка' },
];

export function parseDateTime(dateTimeStr?: string) {
  if (!dateTimeStr) return { date: '', time: '' };
  const date = dateTimeStr.slice(0, 10);
  const time = dateTimeStr.slice(11, 16);
  return { date, time };
}

export function toISODate(date?: string, time?: string) {
  if (!date) return undefined;
  const dateTime = time ? `${date}T${time}:00` : `${date}T00:00:00`;
  const isoString = new Date(dateTime).toISOString();
  if (isoString === 'Invalid Date') return undefined;
  return isoString;
}

export function periodText(dateStart?: string, dateEnd?: string) {
  function formatDate(dateStr?: string) {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
    });
  }
  if (dateStart && dateEnd)
    return `${formatDate(dateStart)} — ${formatDate(dateEnd)}`;
  if (dateStart) return `с ${formatDate(dateStart)}`;
  return null;
}

export function getInitialSelectOption<T extends { id: string | number }>(
  options: T[],
  value: string | number | null | undefined,
  fallbackId?: string | number
): T | null {
  if (value) return options.find((opt) => opt.id === value) || null;
  if (value === null) return null;
  if (fallbackId) return options.find((opt) => opt.id === fallbackId) || null;
  return null;
}

export interface EditBannerForm {
  title: string;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  heading: string;
  description: string;
  buttonType: { id: string | number; title: string } | null;
  buttonText: string;
  image: string;
  textColor: { id: string | number; title: string } | null;
  bgColor: string;
  action: { id: string | number; title: string } | null;
  link: string;
  modal: {
    title: string;
    description: string;
    content: string;
    buttonText: string;
    image: string;
    buttonTextColor: string;
    buttonColor: string;
    link: string;
  };
  isPromotional: boolean;
  status: { id: string | number; title: string } | null;
  promotionalText: string;
}
